/* eslint no-undef: 0 */
import { appName, baseURL, scope } from '@/config/base';
import { getToken } from '@/utils/cookies';
import { message } from '@sinohealth/butterfly-ui-components/lib';
import axios, { AxiosInstance } from 'axios';
import qs from 'qs';

// 默认配置
axios.defaults.timeout = 15000;
axios.defaults.withCredentials = false;
// @ts-ignore
axios.defaults.headers['Content-Type'] = 'application/json';

// console.log('AxiosInstance');
// @ts-ignore
// console.log(AxiosInstance);

interface requestInstance extends AxiosInstance {}
// 普通请求实例
const request: requestInstance = axios.create({
  baseURL,
  maxRedirects: 0,
});

// form-data类型请求实例
const requestFd = axios.create({
  baseURL,
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    biz: scope,
    scope,
    app: appName,
  },
  transformRequest: [
    (data) => {
      Object.keys(data).forEach((key) => {
        if (typeof data[key] === 'object') {
          // eslint-disable-next-line no-param-reassign
          data[key] = JSON.stringify(data[key]);
        }
      });
      return qs.stringify(data);
    },
  ],
});

request.interceptors.request.use((conf: any) => conf);
function beforeRequest(options: any) {
  const newOptions = { ...options };
  const token = getToken();
  if (token) {
    newOptions.headers.Authorization = token;
  }
  newOptions.headers.biz = scope;
  newOptions.headers.scope = scope;
  newOptions.headers.app = appName;
  return newOptions;
}
function resolve(response: any) {
  const { data } = response;
  if (response.config.isFile) {
    return Promise.resolve(response);
  }
  if (data.success) {
    if (response.config.isReturnAllData) {
      return Promise.resolve(data);
    }
    return Promise.resolve(data.data);
  }
  if (!response.config.hiddenErrorMsg) {
    message.error(`${data.errMessage || '服务器出错了，请稍后再试！'}`);
  }
  return Promise.reject(data);
}
function reject(error: any) {
  let errorMessageText = error.errMessage;
  const { response } = error;
  if (response) {
    if (response.status === 401 && !response.config?.noAuthentication) {
      message.error('登录状态已过期，请重新登录');
      window.location.href = '/login';
    }
    errorMessageText = error.response.data && error.response.data.errMessage;
  } else if (error.request) {
    errorMessageText = error.request;
  }
  if (!response?.config?.noAuthentication) {
    message.error(`${errorMessageText || '服务器出错了，请稍后再试！'}`);
  }
  // message.error(`${errorMessageText || '服务器出错了，请稍后再试！'}`);
  if (response?.config?.isReturnAllData) {
    return Promise.reject(error);
  }
  return Promise.reject(error && error.response && error.response.data);
}
request.interceptors.request.use(beforeRequest);
request.interceptors.response.use(resolve, reject);
requestFd.interceptors.response.use(resolve, reject);

export { request, requestFd };
export default request;
